import MarketingBlock from './marketingBlock'

export default MarketingBlock



// WEBPACK FOOTER //
// ./client/pages/home/marketingBlock/index.tsx